<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>用户管理</el-breadcrumb-item>
			<el-breadcrumb-item>用户充值</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>搜索：</div>
				<el-input size="mini" placeholder="账号 / 昵称 / UID / SID" v-model="search.keyword" style="margin-right: 10px; width:280px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="ID" label="编号" align="center" width="100">
					<template slot-scope="scope">
						{{scope.row.id}}
					</template>
				</el-table-column>
				<el-table-column prop="sid" label="店铺" align="center" >
					<template slot-scope="scope">
						{{scope.row.shop_name}}<span style="color: #999999;">({{scope.row.sid}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="uid" label="UID" align="center" width="120">
				</el-table-column>
				<el-table-column prop="username" label="会员账号" align="center" width="120">
				</el-table-column>
				<el-table-column prop="nickname" label="会员昵称" align="center" >
				</el-table-column>
				<el-table-column prop="amount" label="充值金额" align="center" width="160">
				</el-table-column>
				<el-table-column prop="pay_code" label="充值渠道" align="center" width="200">
				</el-table-column>
				<el-table-column prop="status" label="状态" align="center" width="140">
					<template slot-scope="scope">
						<el-tag type="info"  v-if="scope.row.status==0" size="mini">待确认</el-tag>
						<el-tag type="success" v-if="scope.row.status==1" size="mini">充值成功</el-tag>
						<el-tag type="error" v-if="scope.row.status==2" size="mini">充值拒绝</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="充值时间"  align="center">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.add_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="action_time" label="到账时间" align="center">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.action_time)}}
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[14, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
	</div> 
</template>

<script>
	
	export default {
		components: {
		},  
		computed:{
		},
		data(){
			return {
				search:{
					keyword:'',
					status:-1,
					gameType:'',
				},
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:14,
				detailShow:false,
				viewOrid:0,
			}
		},
		created() {
			this.getData();
		},
		methods:{
			viewOrder(scope){
				// this.viewOrid = scope.row.orid;
				// this.detailShow = true;
			},
			closeShow(){
				this.detailShow = false;
			},
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Order/deleteOrder", {orid:scope.row.orid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('是否确认删除此订单？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.deleteApi(scope);
				}).catch(() => {      
				});
			},
			reset(){
				this.search = {
					keyword:'',
					status:'99',
					gameType:'99'
				}
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/User/getUserPayList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(ts) {
				if(ts == 0){
					return '';
				}
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			},
		}
	}
</script>

